var show_probe = null;
var hide_probe = null;

window.showRecaptcha = function(allways = false) {
    if (window.grecaptcha && window.grecaptcha.showAllways) {
        return;
    }
    show_probe = setInterval(function() {
        if (window.grecaptcha.show) {
            window.grecaptcha.showAllways = allways;
            window.grecaptcha.show();
            clearInterval(show_probe);
        }
    },250);
};

window.hideRecaptcha = function() {
    if (window.grecaptcha && window.grecaptcha.showAllways) {
        return;
    }

    hide_probe = setInterval(function() {
        if (window.grecaptcha.hide) {
            window.grecaptcha.hide();
            clearInterval(hide_probe);
        }
    },250);
};

window.onRecaptchaReady = function() {
    window.grecaptcha.readyTimer = null;
    window.grecaptcha.showAllways = null;

    window.grecaptcha.hide = function() {
        setTimeout( function() {
            var el = document.querySelector('.grecaptcha-badge');
            if (el) el.style.display = 'none';
        }, 1);
    }

    window.grecaptcha.show = function() {
        setTimeout( function() {
            var el = document.querySelector('.grecaptcha-badge');
            if (el) {
                el.style.display = 'initial';
                el.style.zIndex = 1060;
            }
        },1);
    }

    window.grecaptcha.trigger = function (actionName, cb) {
        window.grecaptcha
            .execute( window.grcSiteKey, { action:actionName } )
            .then( function(token) {
                cb ? cb(token) : null;
            });
    }

    window.grecaptcha.hide();
};

$(document).ready(function() {
    var captchaForms = document.querySelectorAll('[captcha-action]');

    if(captchaForms.length > 0) {
        window.showRecaptcha(true);
    }

    for (var i=0; i<captchaForms.length; i++) {

        var $form = $(captchaForms[i]);

        var $input = $('<input>').attr({
            type: 'hidden',
            name: 'g-recaptcha-response',
            class : 'recaptchaResponse',
            value: ''
        }).appendTo($form);

        // if we want to preload captcha
        // window.grecaptcha.trigger(action, function(token) { $input.val(token); });

        var action = $form.attr('captcha-action');

        $form.submit(function() {
            if ($input.val() == '') {
                window.grecaptcha.trigger(action, function(token) {
                    $input.val(token);
                    $form.data('submitted','false').submit();
                });
                return false;
            }
            return true;
        })

    }
});